"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TypeResponses;
(function (TypeResponses) {
    var DeliveryTypeListingResponse = /** @class */ (function () {
        /**
        * Response containing multiple types
        * @constructor
        * @param {IContentType[]} types - Content types
        * @param {Pagination} pagination - Pagination object
        */
        function DeliveryTypeListingResponse(types, pagination, debug) {
            this.types = types;
            this.pagination = pagination;
            this.debug = debug;
        }
        return DeliveryTypeListingResponse;
    }());
    TypeResponses.DeliveryTypeListingResponse = DeliveryTypeListingResponse;
    var DeliveryTypeResponse = /** @class */ (function () {
        /**
        * Response containing single type
        * @constructor
        * @param {IContentType} type - Content type
        */
        function DeliveryTypeResponse(type, debug) {
            this.type = type;
            this.debug = debug;
        }
        return DeliveryTypeResponse;
    }());
    TypeResponses.DeliveryTypeResponse = DeliveryTypeResponse;
})(TypeResponses = exports.TypeResponses || (exports.TypeResponses = {}));
//# sourceMappingURL=responses.js.map